import React from 'react'

const AccountDeletion: React.FC = () => {
    return (
        <div className='min-full-screen'>
            <h1 className="mb-3">Delete Your influns Account</h1>

            <p>
                At <b className='p-0'>influns</b>, you have complete control over your data.
                If you want to delete your account, you can request account deletion directly from within the app.
            </p>

            <hr />

            <h3>How to Request Account Deletion</h3>
            <p>Follow these simple steps inside the influns app:</p>
            <ol>
                <li>Open the app and go to the <b className='p-0'>Profile</b> page.</li>
                <li>Scroll down and find the button labeled <b className='p-0'>"Request Deletion"</b>.</li>
                <li>Tap the button to submit your deletion request.</li>
            </ol>

            <div className="alert alert-info">
                ⚠️ <b className='p-0'>Important:</b>
                The <b className='p-0'>"Request Deletion"</b> button only works if your account has
                <b className='p-0'> no active collaborations</b>.
                If you currently have active collaborations, you must complete them first.
            </div>

            <hr />

            <h3>What Happens After You Request Deletion?</h3>
            <ul>
                <li>Your account will be reviewed to ensure there are no active collaborations.</li>
                <li>Once verified, your account will be permanently deleted within <b className='p-0'>7 days</b>.</li>
                <li>All personal information associated with your account will be removed.</li>
                <li>You will receive an email confirmation once deletion is complete.</li>
            </ul>

            <hr />

            <h3>Need Help?</h3>
            <p>
                If you are unable to request deletion from within the app, or if you have any questions,
                you can contact our support team:
            </p>

            <p>
                📧 <b className='p-0'>Email:</b>{" "}
                <a href="mailto:support@influns.com">support@influns.com</a>
            </p>
        </div>
    )
}

export default AccountDeletion
